module.exports = __webpack_public_path__ + "img/Indonesia-3-hover.9a2b3b81.jpg";